module.exports = __webpack_public_path__ + "img/fridge-temperature-log-book_B09JRLJY3C.85d413f5.jpg";